// WelcomePopup.js
import React from 'react';
import skincareImage from '../images/skincare.png'; // Import the image
import './WelcomePopup.css';

const WelcomePopup = ({ onClose }) => {
  return (
     // Overlay for the popup, creating a full-screen dimmed background
    <div className="welcome-popup-overlay">
      {/* Popup container for the welcome message */}
      <div className="welcome-popup">
        {/* Display skincare image at the top of the popup */}
      <img src={skincareImage} alt="Skincare" className="welcome-image" />
        {/* Welcome header text */}
        <h2>Welcome to Curu</h2>
        {/* Description text for the popup */}
        <p>Discover products curated for you</p>
        {/* Close button for the popup, triggering the onClose function when clicked */}
        
        <button onClick={onClose} className="close-popup-button">Let's get started</button>
      </div>
    </div>
  );
};

export default WelcomePopup;

